import { LoadingOutlined } from "@ant-design/icons";
import { notification, Spin } from "antd";
import { Field, Form, Formik } from "formik";
import React, { useEffect, useRef, useState } from "react";
import Modal from "react-modal";
import Select2 from "react-select";

import CloseModal from "../../../components/icons/CloseModal";
import { addChannelValidation } from "../../../utils/validations";

const EditChannel = (props) => {
  const {
    setEditOpen,
    editOpen,
    options,
    editChannelDetail,
    getInviteUser,
    allUsers,
    setAllUsers,
    setLoder,
    createRTMPChannel,
    userSearch,
    setUserSearch,
    fetchChannels,
    loder,
    getOrganizationsByIds,
    setOrganizationSearch,
    id,
  } = props;
  const [selectOrganization, setSelectOrganization] = useState([]);
  const [count, setCount] = useState(0);
  const firstRef = useRef(true);
  const [initialValues, setInitialValues] = useState({
    channelName: "",
    channelid: "",
    region: "",
    access_key: "",
    secret_key: "",
    cdn_suffix: "",
    organization: "",
  });

  const closeModal = () => {
    setEditOpen(false);
    // if (allUsers?.length === 0) {
    //   setSelectOrganization([]);
    // }
  };
  console.log(editChannelDetail, "editChannelDetail");
  const handleChange = (e) => {
    if (editChannelDetail?.state === "start") {
      notification["warning"]({ message: "Channel is in start state cannot change the user!" });
    } else {
      setSelectOrganization(e);
      setInitialValues({ ...initialValues, user: e?.value });
    }
  };

  const handleSubmit = async (values) => {
    setLoder(true);
    const { value } = await createRTMPChannel({
      _id: editChannelDetail?._id,
      channelName: values?.channelName,
      channelId: values?.channelid,
      type: "update",
      creds: {
        region: values?.region,
        accessKey: values?.access_key,
        secretAccessKey: values?.secret_key,
      },
      cdn_suffix: values?.cdn_suffix,
      entityId: id,
    });
    if (value.status == true) {
      fetchChannels();
      notification["success"]({ message: value.message });
    } else {
      notification["error"]({ message: value.message });
    }
    setLoder(false);
    closeModal();
  };
  useEffect(() => {
    if (editChannelDetail) {
      setInitialValues({
        channelName: editChannelDetail?.channelName,
        channelid: editChannelDetail?.channelId,
        region: editChannelDetail?.region,
        cdn_suffix: editChannelDetail?.cdn_suffix,
        access_key: editChannelDetail?.creds?.accessKey,
        secret_key: editChannelDetail?.creds?.secretAccessKey,
      });
      if (editChannelDetail?.entityId) {
        getOrganizationData();
      }
    }
  }, [editChannelDetail]);

  const getOrganizationData = async () => {
    //get list of all organizations assiged to server
    const { value } = await getOrganizationsByIds({
      organizationIds: [editChannelDetail?.entityId],
      includeWorkspaces: true,
    });
    if (value?.status) {
      const orgs = (value.data?.organizations || [])
        .filter((item) => item.organizationId == editChannelDetail?.entityId)
        .map((item) => ({ label: item.name, value: item.organizationId }));
      setSelectOrganization(orgs);
    }
  };

  useEffect(() => {
    if (editChannelDetail) {
      if (editChannelDetail?.user === "") {
        setAllUsers([]);
      }
    }
  }, [editChannelDetail]);

  useEffect(() => {
    if (firstRef.current) {
      firstRef.current = false;
    } else {
      const timer = setTimeout(() => {
        setCount(count + 1);
      }, 500);
      return () => clearTimeout(timer);
    }
  }, [userSearch]);

  useEffect(() => {
    getInviteUser(false);
  }, [count]);
  return (
    <>
      <Modal
        isOpen={editOpen}
        onRequestClose={closeModal}
        shouldCloseOnOverlayClick={false}
        contentLabel="Filter Modal"
        portalClassName="react-modal"
        overlayClassName="modal"
        ariaHideApp={false}
        className="modal-dialog react-modal-dialog-xs modal-dialog-centered"
      >
        <div className="modal-content">
          {/* <AccessControl code="add_team" page="configuration"> */}
          <div className="react-modal-header">
            <h5 className="react-modal-title">Edit Channel</h5>
            <button type="button" onClick={closeModal} className="btn btn__default">
              <CloseModal />
            </button>
          </div>
          {/* </AccessControl> */}
          <Formik
            initialValues={initialValues}
            validationSchema={addChannelValidation}
            enableReinitialize
            onSubmit={handleSubmit}
          >
            {({ errors, touched, setFieldValue, values }) => (
              <Form>
                <div className="react-modal-body">
                  <div className="form-container">
                    <div className="form-group">
                      <label className="form-label">
                        Channel Id <span className="required">*</span>
                      </label>
                      <Field
                        className="form-control"
                        name="channelid"
                        type="text"
                        placeholder="Enter Channel Id"
                        disabled={true}
                      />
                      {touched.channelid && errors.channelid && (
                        <div className="invalid-feedback">{errors.channelid}</div>
                      )}
                    </div>
                    <div className="form-group">
                      <label className="form-label">
                        Channel Name <span className="required">*</span>
                      </label>
                      <Field
                        className="form-control"
                        name="channelName"
                        type="text"
                        placeholder="Enter Channel Name"
                        disabled={true}
                      />
                      {touched.channelName && errors.channelName && (
                        <div className="invalid-feedback">{errors.channelName}</div>
                      )}
                    </div>
                    <div className="form-group">
                      <label className="form-label">
                        Region <span className="required">*</span>
                      </label>
                      <Field
                        className="form-control"
                        name="region"
                        type="text"
                        placeholder="Enter Region"
                        disabled={true}
                      />
                      {touched.region && errors.region && <div className="invalid-feedback">{errors.region}</div>}
                    </div>
                    <div className="form-group">
                      <label className="form-label">
                        CDN SUffix <span className="required">*</span>
                      </label>
                      <Field
                        className="form-control"
                        name="cdn_suffix"
                        type="text"
                        placeholder="Enter CDN Suffix"
                        // disabled={true}
                      />
                    </div>
                    <div className="form-group">
                      <label className="form-label">
                        Organizations<span className="required"></span>
                      </label>
                      <Select2
                        styles={{ width: "100%" }}
                        // isMulti={true}
                        bordered={false}
                        value={selectOrganization}
                        onChange={(e) => {
                          handleChange(e);
                        }}
                        onInputChange={(e) => {
                          setOrganizationSearch(e);
                        }}
                        name="organization"
                        options={options}
                      />
                      {/* {touched.user && errors.user && <div className="invalid-feedback">{errors.user}</div>} */}
                    </div>
                  </div>
                </div>
                <div className="react-modal-footer">
                  <div className="react-foo-container">
                    <div className="right-btn-block text-center">
                      <button type="button" className="btn btn-white" onClick={closeModal}>
                        Cancel
                      </button>
                      <button type="submit" className="btn btn-primary">
                        Edit
                        {loder == false ? (
                          ""
                        ) : (
                          <Spin
                            size="large"
                            indicator={<LoadingOutlined style={{ fontSize: 50, color: "#000", marginLeft: 50 }} spin />}
                            className="loader__full"
                          ></Spin>
                        )}
                      </button>
                    </div>
                  </div>
                </div>
              </Form>
            )}
          </Formik>
        </div>
      </Modal>
    </>
  );
};

export default EditChannel;
